import React from "react";

const WIDTHS = ["w-16", "w-20", "w-14", "w-24"];

const TagSkeleton: React.FC = () => (
  <div className="flex flex-wrap items-center gap-2" aria-hidden>
    {WIDTHS.map((w, i) => (
      <div
        key={i}
        className={`bg-cream-300 dark:bg-cream-700 h-8 ${w} animate-pulse rounded-full`}
      />
    ))}
  </div>
);

export default TagSkeleton;
